<template>
  <DefaultLayout>
    <div v-if="getProfile.is_paid" class="h-full grid grid-cols-12 px-5 py-3">
      <div :class="[{
        '2xl:col-span-10 lg:col-span-9 md:col-span-8 col-span-12 h-full flex flex-col space-y-3': hasTeacherPermissionsInCourse,
        'col-span-12 h-full flex flex-col space-y-3': !hasTeacherPermissionsInCourse
      }]">
        <div class="flex justify-between items-center">
          <div class="flex items-center">
            <div v-if="hasTeacherPermissionsInCourse" class="flex items-center space-x-1.5 bg-white border border-gray-300 rounded-full py-1.5 px-1.5">
              <button @click="previousUser()" class="text-gray-600 hover:text-blueGray-600 w-6 h-6 rounded-full  hover:bg-gray-100 flex items-center justify-center">
                <i class="fa-solid fa-angle-left text-sm"></i>
              </button>
              <div class="flex items-center">
                <img :src="selectedStudent.avatar_url" class="w-6 h-6 rounded-full"></img>
                <h6 class="ml-2 font-bold font-manrope text-blueGray-800 text-lg">
                  {{ selectedStudent.name }}
                </h6>
              </div>
              <button @click="nextUser()" class="text-gray-600 hover:text-blueGray-600 w-6 h-6 rounded-full  hover:bg-gray-100 flex items-center justify-center">
                <i class="fa-solid fa-angle-right text-sm"></i>
              </button>
            </div>
            <div v-else>
              <div class="flex items-center mr-3">
                <img :src="selectedStudent.avatar_url" class="rounded-full border-2 shadow border-white-400 w-9 h-9" />
                <h3 class="ml-3 font-bold font-manrope text-blueGray-800 text-lg">
                  {{ selectedStudent.name }}
                </h3>
              </div>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <div v-if="$route.name === 'course.student-reports.summary'" class="flex items-center">
              <DatePicker
                class="bg-white border border-gray-300 border-solid rounded px-6 py-1.5 w-60 text-center cursor-pointer outline-none"
                v-model="date"
                :config="config"
                placeholder="Select a Date to Filter"
                @on-change="setDateAndReloadCharts"
              />
              <div v-if="$route.query.startDate && $route.query.endDate">
                <button
                  @click="clearDates()"
                  class="bg-gray-300 rounded px-4 py-2 text-white ml-1 font-semibold"
                >
                  Clear
                </button>
              </div>
            </div>
            <div v-if="hasTeacherPermissionsInCourse" class="flex items-center">
              <button
                @click="exportStudentReport()"
                role="button"
                aria-label="Export"
                class="sample flex items-center space-x-2 px-3.5 py-1.5 bg-gray-50 border border-solid border-gray-400 hover:border-gray-500 hover:bg-gray-100 text-blueGray-800 rounded  font-semibold text-sm"
              >
                <span class="font-poppins font-normal">Export</span>
                <i class="fa-solid fa-cloud-arrow-down mr-2"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="max-w-screen-3xl">
          <div class="bg-white text-sm relative cursor-default rounded border border-coolGray-200 py-2">
            <div class="flex justify-between border-b border-coolGray-200 h-7 mb-2">
              <div>
                <button
                  v-for="(selectedTab, index) in displayableTabs"
                  :key="index"
                  :class="isSelectedTab(selectedTab.routeName) ? ['text-primary border-solid	border-b-2 pb-1.5 border-primary']: []"
                  class="text-sm text-blueGray-600 cursor-pointer px-5 border-0"
                  @click="goToTab(selectedTab.routeName)"
                >
                  {{ selectedTab.title }}
                </button>
              </div>
            </div>
            <SummaryTab 
              v-if="selectedTab === 'course.student-reports.summary'" 
            />
            <DiscussionTab
              class="h-full"
              v-if="selectedTab === 'course.student-reports.discussion'"
              @showTemplateModal="templates_modal = true"
            />
          </div>
        </div>
      </div>
      <div v-if="hasTeacherPermissionsInCourse" class="2xl:col-span-2 lg:col-span-3 md:col-span-4 col-span-12 h-full">
        <div class="sticky top-1">
          <ClassList
            @selectedStudent="selectedStudentFromClassList"
            :selectedStudentStyle="styleColorClassList"
            @sorted_list_students="(students_list) => handleSetStudentsClass(students_list)"
          />
        </div>
      </div>
    </div>
    <div v-if="!getProfile.is_paid && hasTeacherPermissionsInCourse" class="h-full grid grid-cols-12 px-5 py-3 mb-5">
      <div class="2xl:col-span-10 lg:col-span-9 md:col-span-8 col-span-12 h-full flex flex-col space-y-3">
        <div class="flex justify-between items-center">
          <div class="flex items-center">
            <div  class="flex items-center space-x-1.5 bg-white border border-gray-300 rounded-full py-1.5 px-1.5">
              <button @click="handleUpgrade()" class="text-gray-600 hover:text-blueGray-600 w-6 h-6 rounded-full  hover:bg-gray-100 flex items-center justify-center">
                <i class="fa-solid fa-angle-left text-sm"></i>
              </button>
              <div class="flex items-center">
                <img src="https://parlay-api.herokuapp.com/api/files/1599763924317-Screen Shot 2020-09-10 at 2.51.47 PM.png" class="w-6 h-6 rounded-full"></img>
                <h6 class="ml-2 font-bold font-manrope text-blueGray-800 text-lg">
                  Angela Ortiz
                </h6>
              </div>
              <button @click="handleUpgrade()" class="text-gray-600 hover:text-blueGray-600 w-6 h-6 rounded-full  hover:bg-gray-100 flex items-center justify-center">
                <i class="fa-solid fa-angle-right text-sm"></i>
              </button>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <div v-if="$route.name === 'course.student-reports.summary'" class="flex items-center">
              <DatePicker
                class="bg-white border border-gray-300 border-solid rounded px-6 py-1.5 w-60 text-center cursor-pointer outline-none"
                v-model="date"
                :disabled="true"
                :config="config"
                placeholder="Select a Date to Filter"
                @on-change="setDateAndReloadCharts"
              />
            </div>
            <div v-if="hasTeacherPermissionsInCourse" class="flex items-center">
              <button
                role="button"
                aria-label="Export"
                @click="handleUpgrade()"
                class="sample flex items-center space-x-2 px-3.5 py-1.5 bg-gray-50 border border-solid border-gray-400 hover:border-gray-500 hover:bg-gray-100 text-blueGray-800 rounded  font-semibold text-sm"
              >
                <span class="font-poppins font-normal">Export</span>
                <i class="fa-solid fa-cloud-arrow-down mr-2"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="max-w-screen-3xl">
          <div class="bg-white text-sm relative cursor-default rounded border border-coolGray-200 py-2">
            <div class="flex justify-between border-b border-coolGray-200 h-7 mb-2">
              <div>
                <button
                  v-for="(selectedTab, index) in displayableTabs"
                  :key="index"
                  @click="handleUpgrade()"
                  :class="isSelectedTab(selectedTab.routeName) ? ['text-primary border-solid	border-b-2 pb-1.5 border-primary']: []"
                  class="text-sm text-blueGray-600 cursor-pointer px-5 border-0"
                >
                  {{ selectedTab.title }}
                </button>
              </div>
            </div>
            <SummaryTab 
              v-if="selectedTab === 'course.student-reports.summary'" 
            />
          </div>
        </div>
      </div>
      <div class="2xl:col-span-2 lg:col-span-3 md:col-span-4 col-span-12 h-full">
        <div class="sticky top-1">
          <ClassList
            @selectedStudent="selectedStudentFromClassList"
            :selectedStudentStyle="styleColorClassList"
            @sorted_list_students="(students_list) => handleSetStudentsClass(students_list)"
          />
        </div>
      </div>
    </div>
    <TemplatesModal
      v-if="templates_modal"
      :activityType="rt_type"
      @close="closeTemplateModal"
    />
    <NewFeedbackTemplateModal
      v-if="show_saved_feedback_modal"
      @close="closeNewFeedbackModal"
      :typeRoundtable="rt_type === 'written' ? 'online' : 'live'"
      :feedbackID="feedback_id"
      :feedbackContent="feedback_content"
      :editingFeedback="set_edit_saved_feedback"
    />
    <ImportFeedbackTemplatesModal
      v-if="show_import_feedback_modal"
      @close="closeImportFeedbackTemplatesModal"
      :typeRoundtable="rt_type === 'written' ? 'online' : 'live'"
    />
    <dialog-delete-confirm
      v-if="show_confirm_delete_feedback"
      @close="cancelDeleteSavedFeedback"
      @actionConfirmed="confirmDeleteSavedFeedback"
      :header="'Delete this saved feedback template'"
      :subHeader="'It will be permanently removed from this course.'"
    />
  </DefaultLayout>
</template>

<script>
  import Vue from 'vue';
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import Service_ExportStudentReportData from 'services/courses/exportStudentReportData';
  import DownloadFile from 'utils/downloadFile';
  import { EventBus } from '../../../../utils/event-bus';
  import dialogDeleteConfirm from 'components/dialogDeleteConfirm';
  import ReportDiscussionTab from './ReportDiscussionTab.vue';

  export default Vue.extend({
    components: {
      DefaultLayout: () => import('../../../../layouts/default/default.vue'),
      ClassList: () => import('./ClassList.vue'),
      SummaryTab: () => import('./SummaryTab.vue'),
      DiscussionTab: () => import('./DiscussionStudentTab.vue'),
      DatePicker: () => import('vue-flatpickr-component'),
      TemplatesModal: () => import('components/modals/templatesModal.vue'),
      ImportFeedbackTemplatesModal: () => import('components/modals/ImportFeedbackModal.vue'),
      NewFeedbackTemplateModal: () => import('components/modals/NewFeedbackModal.vue'),
      dialogDeleteConfirm,
      ReportDiscussionTab
    },
    watch: {
      '$route.name': function () {
        this.date = '';
      },
      '$route.params': function () {},
      students_list_class: function (newValue) {
        this.selectedStudent = newValue[0];
        this.$router.replace({
          name: this.$route.name,
          params: { studentID: newValue[0].id },
        });
      },
    },
    data() {
      return {
        isClassListOpen: true,
        selectedTab: '',
        selectedStudent: {},
        styleColorClassList: '',
        isLoading: false,
        selectedDateStart: '',
        selectedDateEnd: '',
        date: '',
        config: {
          wrap: true,
          mode: 'range',
          dateFormat: 'Y-m-d',
          altInput: true,
          altFormat: 'F j, Y',
        },
        templates_modal: false,
        rt_type: '',
        set_edit_saved_feedback: false,
        show_import_feedback_modal: false,
        show_saved_feedback_modal: false,
        feedback_id: '',
        feedback_content: '',
        show_confirm_delete_feedback: false,
        feedback_to_delete: {},
        students_list_class: [],
        sorted_by: 'last-name-desc',
      };
    },
    computed: {
      ...mapGetters([
        'getCourseDetail',
        'hasTeacherPermissionsInCourse',
        'getStudentsInCourse',
        'getProfile',
      ]),
      studentsInCourse: function () {
        return this.getStudentsInCourse;
      },
      courseSettingsTitle: function () {
        const section = this.section ? `- ${this.section}` : '';
        return `${this.title} ${section} - Course Settings`;
      },
      displayableTabs: function () {
        const tabs = [
          { title: 'Summary', routeName: 'course.student-reports.summary' },
          {
            title: 'Discussions',
            routeName: 'course.student-reports.discussion',
          },
        ];
        return tabs;
      },
    },
    methods: {
      handleUpgrade: function() {
        const text = 'student reports and data export feature for all your classes.';
        EventBus.$emit('open-upgrade-modal', text);
      },
      handleSetStudentsClass: function (sorted_by_new) {
        if (sorted_by_new === this.sorted_by) return;
        if (sorted_by_new === 'name-desc') {
          this.sorted_by = 'name-desc';
          this.students_list_class = this.getStudentsInCourse.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
        }
        if (sorted_by_new === 'name-asc') {
          this.students_list_class = this.getStudentsInCourse.sort((a, b) => {
            return b.name.localeCompare(a.name);
          });
          this.sorted_by = 'name-asc';
        }
        if (sorted_by_new === 'last-name-desc') {
          this.students_list_class = this.getStudentsInCourse.sort((a, b) => {
            return a.lastName.localeCompare(b.lastName);
          });
          this.sorted_by = 'last-name-desc';
        }
        if (sorted_by_new === 'last-name-asc') {
          this.students_list_class = this.getStudentsInCourse.sort((a, b) => {
            return b.lastName.localeCompare(a.lastName);
          });
          this.sorted_by = 'last-name-asc';
        }
        return;
      },
      goToTab: function (routeName) {
        this.$router.push({ name: routeName });
        this.selectedTab = routeName;
        routeName === 'course.student-reports.summary' ? (this.selectedTab = 'course.student-reports.summary') : (this.selectedTab = 'course.student-reports.discussion');
      },
      isSelectedTab: function (tabName) {
        return this.$route.name === tabName;
      },
      selectedStudentFromClassList: function (student) {
        this.selectedStudent = student;
        this.$router.replace({
          name: this.$route.name,
          params: { studentID: student.id },
        });
      },
      exportStudentReport: function () {
        const { courseID, studentID } = this.$route.params;
        if (this.$route.query.startDate && this.$route.query.endDate) {
          const dateStart = moment.unix(this.$route.query.startDate).format('YYYY/MM/DD') + ' ' + '00:00:00';
          const dateEnd = moment.unix(this.$route.query.endDate).format('YYYY/MM/DD') + ' ' + '23:59:59';
          Service_ExportStudentReportData(courseID,studentID, dateStart, dateEnd).then((res) => {
            const file = res.data;
            const filename = `${this.getCourseDetail.title}-${this.selectedStudent.name}.xlsx`;
            DownloadFile(file, filename, 'xlsx');
          });
        } else {
          const start = '';
          const end = '';
          Service_ExportStudentReportData(courseID, studentID, start, end).then((res) => {
            const file = res.data;
            const filename = `${this.getCourseDetail.title}-${this.selectedStudent.name}.xlsx`;
            DownloadFile(file, filename, 'xlsx');
          });
        }
      },
      setDateAndReloadCharts: function (values) {
        if (!values[0] || !values[1])
          this.$router.replace({
            name: this.$route.name,
            params: this.$route.params,
          });
        if (values[0] && values[1]) {
          this.selectedDateStart = values[0];
          this.selectedDateEnd = values[1];
          this.$router.replace({
            name: this.$route.name,
            params: this.$route.params,
            query: {
              startDate: moment(this.selectedDateStart).format('X'),
              endDate: moment(this.selectedDateEnd).format('X'),
            },
          });
          this.selectedDateStart = '';
          this.selectedDateEnd = '';
        }
      },
      clearDates: function () {
        this.date = '';
        this.$router.replace({
          name: this.$route.name,
          params: this.$route.params,
        });
      },
      nextUser: function () {
        const { studentID } = this.$route.params;
        const currentSelectedUser = studentID;
        const currentPosition = this.students_list_class.findIndex((student) => student.id === currentSelectedUser);
        const nextPosition = (currentPosition + 1) % this.students_list_class.length;
        const nextStudent = this.students_list_class[nextPosition];
        
        this.$router.replace({ name: this.$route.name, params: { studentID: nextStudent.id } });
        this.selectedStudent = nextStudent;
      },
      previousUser: function () {
        const { studentID } = this.$route.params;
        const currentSelectedUser = studentID;
        const currentPosition = this.students_list_class.findIndex((student) => student.id === currentSelectedUser);
        const previousPosition = (currentPosition - 1 + this.students_list_class.length) % this.students_list_class.length;
        const previousStudent = this.students_list_class[previousPosition];
        
        this.$router.replace({ name: this.$route.name, params: { studentID: previousStudent.id } });
        this.selectedStudent = previousStudent;
      },
      closeTemplateModal() {
        this.templates_modal = false;
        EventBus.$emit('assessment-focus');
      },
      closeNewFeedbackModal: function () {
        this.show_saved_feedback_modal = false;
        this.set_edit_saved_feedback = false;
        this.feedback_id = '';
        this.feedback_content = '';
        EventBus.$emit('showTemplateModal', this.rt_type);
      },
      closeImportFeedbackTemplatesModal() {
        this.show_import_feedback_modal = false;
        EventBus.$emit('showTemplateModal', this.rt_type);
      },
      confirmDeleteSavedFeedback() {
        this.$store
          .dispatch('deleteFeedback', {
            course_id: this.getCourseDetail.id,
            feedback_id: this.feedback_to_delete.id,
            onlineRT: this.rt_type === 'written' ? true : false,
          })
          .then(() => {
            this.feedback_to_delete = {};
            this.show_confirm_delete_feedback = false;
          });
      },
      cancelDeleteSavedFeedback() {
        this.show_confirm_delete_feedback = false;
        EventBus.$emit('showTemplateModal', this.rt_type);
      },
    },
    beforeMount: async function () {
      if (this.getCourseDetail.id === null) {
        await this.$store.dispatch(
          'fetchCourseDetails',
          this.$route.params.courseID
        );
        this.selectedStudent = this.getStudentsInCourse.find(
          (user) => user.id === this.$route.params.studentID
        );
      }
    },
    mounted: async function () {
      this.selectedTab = this.$route.name;

      if (!this.hasTeacherPermissionsInCourse) {
        this.selectedStudent = this.getProfile;
      }

      if (this.getProfile.is_paid === false && this.hasTeacherPermissionsInCourse) {
        EventBus.$emit('createToast', {type: 'Info', message: 'Hey, this is just a Demo!', time: 5000 });
      }

      if (this.getProfile.is_paid === true && this.hasTeacherPermissionsInCourse) {
        if (this.getCourseDetail.id === null) {
          await this.$store.dispatch('fetchCourseDetails', this.$route.params.courseID);
        }

        this.selectedStudent = this.getStudentsInCourse.find((user) => user.id === this.$route.params.studentID);

        this.$router.replace({
          name: this.$route.name,
          params: { studentID: this.$route.params.studentID },
        });

        this.students_list_class = this.getStudentsInCourse.sort((a, b) => {
          const aLN = a.lastName || '';
          const bLN = b.lastName || '';
          return aLN.localeCompare(bLN);
        });
      }

      EventBus.$on('showTemplateModal', (value) => {
        this.templates_modal = true;
        this.rt_type = value;
      });
      EventBus.$on('newSavedFeedback', () => {
        this.show_saved_feedback_modal = true;
      });
      EventBus.$on('showImportFeedback', () => {
        this.show_import_feedback_modal = true;
      });
      EventBus.$on('editSavedFeedback', (value) => {
        this.feedback_id = value.feedback_id;
        this.feedback_content = value.feedback_content;
        this.show_saved_feedback_modal = true;
        this.set_edit_saved_feedback = true;
      });

      EventBus.$on('deleteSavedFeedback', (value) => {
        this.feedback_to_delete = value;
        this.show_confirm_delete_feedback = true;
      });

      EventBus.$on('handleChangeReportsTab', (tab, roundtableId) => {
        this.$router.push({ name: tab, query: { roundtableId: roundtableId } });
        this.selectedTab = tab;
        tab === 'course.student-reports.summary' ? (this.selectedTab = 'course.student-reports.summary') : (this.selectedTab = 'course.student-reports.discussion');
      });
    },
    beforeDestroy() {
      EventBus.$off('showTemplateModal');
      EventBus.$off('editSavedFeedback');
      EventBus.$off('deleteSavedFeedback');
      EventBus.$off('showImportFeedback');
      EventBus.$off('newSavedFeedback');
      EventBus.$off('handleChangeReportsTab');
    },
  });
</script>



// WEBPACK FOOTER //
// StudentReports.vue?75e25fb5